import { Component, Input } from '@angular/core';
import {
    PlatformService, LoggingService, TokenService, LocalStorageService, NotificationsService,
    StripeService, PriceService, AccountService, SelectableTicket, TicketsService
} from '@varsity/services';
import { PopoverController, ToastController, NavParams } from 'ionic-angular';
import {
    BaseComponent
} from '@varsity/components';
import { DomSanitizer } from '@angular/platform-browser';
import { setTimeout } from 'timers';
import { InAppBrowser } from '@ionic-native/in-app-browser';


/**
 * Generated class for the IosWalletComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'google-wallet',
    templateUrl: 'google-wallet.html'
})
export class GoogleWalletComponent extends BaseComponent {
    @Input() curTicket: SelectableTicket;
    //redirectLink: SafeHtml;
    ticketAdded: boolean = false;
    jwt: string = '';

    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected accountService: AccountService,
        protected stripeService: StripeService,
        protected ticketService: TicketsService,
        protected domSanitizer: DomSanitizer,
        protected iab: InAppBrowser,
        protected navParams: NavParams
    ) {

        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "GoogleWalletComponent"
        );

    }

    ngOnInit() {
        super.ngOnInit();

        // https://blog.angular-university.io/angular-debugging/

        setTimeout(() => {
            // this generates an error as it modifies the "showSpinner" flag

            this.platformService.webAppFlag$
                .takeUntil(this.componentDestroyed$)
                .subscribe(
                    (isWebApp) => {
                        this.tokenService.ensureValidToken().then((token) => {
                            let customerID = (this.getUser() ? this.getUser().CustomerID : 0);

                            this.ticketService.getGoogleWalletLink(customerID, this.curTicket, this.navParams.get("validationToken"))
                                .takeUntil(this.componentDestroyed$)
                                .subscribe((value) => {
                                    //this.redirectLink = this.domSanitizer.bypassSecurityTrustHtml(`<g:savetoandroidpay jwt="${value}" size="small" theme="light" ></g:savetoandroidpay>`);

                                    if (isWebApp) {
                                        // is web app
                                        // https://developers.google.com/pay/passes/reference/s2w-reference
                                        (window as any).gapi.savetoandroidpay.render(`jwt-render-${this.curTicket.EventID}-${this.curTicket.Level.trim()}-${this.curTicket.Section.trim()}-${this.curTicket.Row.trim()}-${this.curTicket.Seat.trim()}`, {
                                            "jwt": value,
                                            "height": "small",
                                            "size": "matchparent",
                                            "theme": "light",
                                            "onsuccess": "successHandler",
                                            "onfailure": "failureHandler"
                                        });
                                    } else {
                                        this.jwt = value;
                                    }
                                });
                        });
                    });
        }, 0);

        this.notificationsService.windowMessage$
            .takeUntil(this.componentDestroyed$)
            .subscribe((message) => {
                if (message && message.data && message.data.type) {
                    this.loggingService.debug("google play notification", message);
                }
            });
    }

    setTicketWalletFlag(): void {
        this.ticketAdded = !this.ticketAdded;
        if (this.ticketAdded) {

            this.showNotification("Ticket added to wallet.", undefined, undefined, "success");
        }
    }

    openTab(ev) {
        ev.preventDefault();
        const browser = this.iab.create(`https://pay.google.com/gp/v/save/${this.jwt}`, "_system");
        this.ticketAdded = true;
    }
}



// WEBPACK FOOTER //
// ./src/components/google-wallet/google-wallet.ts